import slice from "./cannibalisationSlice";

export default slice.reducer;
